import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { Tabs, Tab } from "../../components/Tab";

const ServiceOnlineOrderPage = () => {
  const [isVisible, setIsVisible] = useState<boolean[]>([false]);

  // text 애니메이션
  const hideRefs = [
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;

      hideRefs.forEach((ref, index) => {
        const element = ref.current;
        if (element) {
          const elementTop = element.offsetTop;
          const elementHeight = element.offsetHeight;
          const isElementVisible =
            scrollTop + windowHeight > elementTop &&
            scrollTop < elementTop + elementHeight;
          setIsVisible((prev) => {
            const newVisible = [...prev];
            newVisible[index] = isElementVisible;
            return newVisible;
          });
        }
      });

      if (scrollTop + windowHeight === documentHeight) {
        setIsVisible((prev) => {
          const newVisible = [...prev];
          newVisible[newVisible.length - 1] = true;
          return newVisible;
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Style>
      <div className="wrap">
        <div className="bannerTitle mobileView">
          <h1
            ref={hideRefs[4]}
            className={` ${isVisible[4] ? "in_view fade_in" : "fade_in"}`}
          >
            ONLINE ORDER
          </h1>
          <h2>
            핸드폰에서도 간편하게
            <br />
            배달 주문하세요!
          </h2>
        </div>
        <div className="banner">
          <img
            src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webOnlineOrderImage01.png"
            alt="주문서인쇄는 그만! 효율적인 매장 운영이 가능한 kds"
            className="webOnlineOrder01"
          />
        </div>
        <div className="contentWrap">
          <div className="content">
            <h1
              ref={hideRefs[0]}
              className={` ${isVisible[0] ? "in_view fade_up" : "fade_up"}`}
            >
              언제 어디서나 간편하게 주문
            </h1>
            <h2>기기가 필요 없이 QR만 있으면 어디서나 주문 가능합니다.</h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webOnlineOrderImage02.png"
              alt="언제 어디서든 주문이 가능한 온라인오더"
              className="webOnlineOrder02"
            />
          </div>
          <div className="content">
            <h1
              ref={hideRefs[1]}
              className={` ${isVisible[1] ? "in_view fade_up" : "fade_up"}`}
            >
              앱 설치, 회원가입은 NO!
            </h1>
            <h2>QR만 있으면 주문 가능합니다.</h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webOnlineOrderImage03.png"
              alt="앱설치, 회원가입 없이 QR코드만 있으면 주문 가능한 온라인오더"
              className="webOnlineOrder03"
            />
          </div>
          <div className="content">
            <h1
              ref={hideRefs[2]}
              className={` ${isVisible[2] ? "in_view fade_up" : "fade_up"}`}
            >
              카드등록 후 간편결제
            </h1>
            <h2>카드를 등록하고 단골 고객을 확보할 수 있습니다.</h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webOnlineOrderImage04.png"
              alt="간편결제가 가능한 온라인오더"
              className="webOnlineOrder04"
            />
          </div>
          <div className="content">
            <h1
              ref={hideRefs[3]}
              className={` ${isVisible[3] ? "in_view fade_up" : "fade_up"}`}
            >
              배달 현황 알람
            </h1>
            <h2 style={{whiteSpace: "nowrap"}}>
              배달 현황이 바뀔 때 마다 PUSH 알람으로 알려드려요
              <br />
              *모바일 기기 환경에 따라 다릅니다.
            </h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webOnlineOrderImage05.png"
              alt="배달현황 확인이 가능한 온라인오더"
              className="webOnlineOrder05"
            />
          </div>
        </div>
      </div>
    </Style>
  );
};

export default ServiceOnlineOrderPage;
const Style = styled.div`
  h1,
  h2,
  h3,
  h4 {
    text-align: center;
  }
  h1 {
    font-size: 36px;
    font-weight: 700;
    line-height: 50px;
    color: #333;
  }
  h2 {
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    color: #979797;
  }
  h3 {
    font-size: 68px;
    font-weight: 700;
    line-height: 95px;
  }
  h4 {
    font-size: 36px;
    font-weight: 500;
    color: #979797;
    line-height: 50px;
  }

  /* wrap */
  .wrap {
    width: 100%;
    max-width: 100%;
    margin-top: 100px;

    img {
      width: 100%;
    }
  }

  /* banner */
  .banner {
    width: 100%;
  }

  /* contentWrap */
  .contentWrap {
    width: 100%;
    padding: 60px 30%;

    .content {
      padding: 120px 0;

      h1 {
        margin-bottom: 32px;
      }
      img {
        margin-top: 50px;
      }
    }
  }
  .content:nth-child(3),
  .content:nth-child(4) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 50%;
    }
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;

    h1,
    img {
      margin: 0 !important;
    }
  }

  @media (max-width: 1100px) {
    h1 {
      font-size: 28px;
      font-weight: 700;
    }
    h2 {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }
    h3 {
      font-size: 32px;
      line-height: 44px;
    }
    h4 {
      font-size: 18px;
      line-height: 25px;
    }
    .wrap {
      margin-top: 70px;
    }
    .bannerTitle {
      h1 {
        font-size: 40px;
        line-height: 48px;
      }
      h2 {
        margin: 30px 0 40px 0;
        font-size: 16px;
        line-height: 25px;
      }
    }
    .contentWrap {
      padding: 40px 5vw;

      .content {
        padding: 40px 0;

        h1 {
          margin-bottom: 12px;
        }
        img {
          margin-top: 30px;
        }
      }
    }
    .footerContent {
      h3 {
        padding: 7px 5vw 30px 5vw;
      }
      h4 {
        margin-top: 0;
      }
    }

    /* 이미지 변경 */
    .webOnlineOrder01 {
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileOnlineOrderImage01.png");
    }
  }
`;
